var SettingsModule = (function () {
    function SettingsModule() {
    }
    return SettingsModule;
}());
export { SettingsModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.module.ts.pre-build-optimizer.js